<div layout-vertical>
  <div (click)="toggleOpenClose.emit()">
    <ng-template [ngTemplateOutlet]="triggerTemplate"></ng-template>
  </div>
  <div [@openClose]="!(!open && canClose)" class="collapse-wrap">
    <ng-content></ng-content>
  </div>
</div>
